<template>
  <div>
    <v-dialog
      v-model="isShow"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Invita professionista nella pratica</span>
        </v-card-title>
        <v-card-text>
          <p>Inserisci l'indirizzo email del professionista per invitarlo nella pratica.</p>
          <v-form
            ref="formInvite"
            @submit.prevent="inviteProfessional"
          >
            <v-row class="ma-0">
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="formInvite.email"
                  label="Email"
                  type="email"
                  outlined
                  required
                  dense
                  :rules="[formRules.required,formRules.emailRules]"
                  :disabled="loadingBtn"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn
                  class="ma-2"
                  :disabled="loadingBtn"
                  @click="closeModal"
                >
                  Chiudi
                </v-btn>
                <v-btn
                  color="primary"
                  class="ma-2"
                  :loading="loadingBtn"
                  :disabled="loadingBtn"
                  @click.prevent="inviteProfessional"
                >
                  Invita
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InviteProfessional',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    procedureData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formInvite: {},
      loadingBtn: false,
    }
  },
  computed: {
    ...mapGetters(['formRules', 'procedureList']),
  },
  methods: {
    async inviteProfessional() {
      if (this.$refs.formInvite.validate()) {
        try {
          this.loadingBtn = true
          await this.$api.inviteProfessional(this.procedureData.id, this.formInvite)
          await this.$store.dispatch('set_alert', { msg: 'Invito spedito con successo', type: 'success' })
          this.closeModal()
          this.loadingBtn = false
        } catch (e) {
          this.loadingBtn = false
          this.procedure_id = null
          await this.$store.dispatch('set_alert', { msg: 'error', type: 'error' })
        }
      }
    },
    closeModal() {
      this.procedure_id = null
      this.$refs.formInvite.reset()
      this.$emit('close')
      this.loading = false
    },
  },
}
</script>

<style scoped>

</style>
